module.exports = __webpack_public_path__ + "img/c6.f74b64c3.png";